/** Bethlehem Baptist Church — BHG meeting location */
export const MAP_PLACE_QUERY =
  'Bethlehem Baptist Church, 8400 Poole Road, Knightdale, NC 27545';

export const CHURCH_MAP_LOCATION: google.maps.LatLngLiteral = {
  lat: 35.750145,
  lng: -78.481834,
};

/** Neighborhood context around the church (pin stays centered) */
export const CHURCH_MAP_ZOOM = 14;

export const MAPS_LINK_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAP_PLACE_QUERY)}`;

/**
 * Embed API fallback (view mode — zoomed map only, no place info card).
 * Avoids `place` mode, which always shows the white name/address/rating panel.
 */
export function getMapEmbedViewUrl(apiKey: string): string {
  const center = `${CHURCH_MAP_LOCATION.lat},${CHURCH_MAP_LOCATION.lng}`;
  return `https://www.google.com/maps/embed/v1/view?key=${encodeURIComponent(apiKey)}&center=${center}&zoom=${CHURCH_MAP_ZOOM}`;
}
